import { Box, Typography } from '@pocketlaw/tetris';
export function MetadataSection(props) {
    const { title, children } = props;
    return (<Box flexDirection="column" gap="md">
      <Typography $fontWeight="semibold" $fontSize="small">
        {title}
      </Typography>
      {children}
    </Box>);
}
